import { combineReducers, CombinedState } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import ProfileStateReducer, { CombinedProfileState } from "./profile/Reducer";
import ProgressStateReducer from "./progress/Reducer";
import AuthStateReducer, { AuthState } from "./auth/Reducer";

export interface AppState {
  profileState: CombinedProfileState;
  progressState: any;
  authState: AuthState;
}

const appReducer = combineReducers<AppState>({
  profileState: ProfileStateReducer,
  progressState: ProgressStateReducer,
  authState: AuthStateReducer,
});

const rootReducer: any = (
  state: AppState | undefined,
  action: any
): CombinedState<AppState> => {
  if (action.type === "RESET_STORE") {
    storage.removeItem("persist:ezifinLoanApp");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "ezifinLoanApp",
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,
    }),
  devTools: process.env.REACT_APP_ENV !== "production",
});
export const persistor = persistStore(store);
export default store;
